import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Pagination } from "../shared/interfaces/pagination";
import { Observable } from "rxjs";
import { PaginatedResponse } from "../models/paginated-response";
import { environment } from "../../environments/environment";
import { TractorModel } from "../models/tractor.model";

export interface TractorsFilter {
  organizationId?: number;
  description?: string;
  showDeleted?: boolean;
}

@Injectable()
export class TractorDataSource {
  constructor(
    private http: HttpClient
  ) {
  }

  findAll(pagination: Pagination = {}, tractorFilters?: TractorsFilter): Observable<PaginatedResponse<TractorModel>> {
    const params = {};
    if (pagination?.pageNumber) {
      params['pageNumber'] = pagination.pageNumber;
    }

    if (pagination?.removeLimit) {
      params['removeLimit'] = pagination.removeLimit;
    }

    if (pagination?.pageSize) {
      params['pageSize'] = pagination.pageSize;
    }

    if (tractorFilters?.organizationId) {
      params['organizationId'] = tractorFilters.organizationId;
    }

    if (tractorFilters?.showDeleted) {
      params['showDeleted'] = true;
    }

    if (tractorFilters?.description && tractorFilters.description !== '') {
      params['description'] = tractorFilters.description;
    }

    return this.http.get<PaginatedResponse<TractorModel>>(
      environment.backendApi + 'api/Tractors',
      {params}
    );
  }

  delete(tractorId: number): Observable<void> {
    return this.http.delete<void>(environment.backendApi + `api/Tractors/${tractorId}`);
  }

  create(body: Partial<TractorModel>, imageFile: File) {
    const formData = new FormData();
    formData.append('modelData', JSON.stringify(body));
    if (imageFile && imageFile.size > 0 ) {
      formData.append('imageFile', imageFile);
    }

    console.log("create tractor data", formData, "imageFile", imageFile);
    return this.http.post<TractorModel>(environment.backendApi + 'api/Tractors', formData);
  }

  update(id: number, body: Partial<TractorModel>, imageFile: File) {
    const formData = new FormData();
    formData.append('modelData', JSON.stringify(body));
    if (imageFile && imageFile.size > 0 ) {
      formData.append('imageFile', imageFile);
    }

    console.log("update tractor data", formData);
    return this.http.put<TractorModel>(environment.backendApi + `api/Tractors/${id}`, formData);
  }
}
